import type { OriginKind } from '@sbc/domain-models/agents';

import { Badge } from '@/components/ui/badge';

const LABEL: Record<OriginKind, string> = {
  spawn: 'spawn',
  handoff: 'handoff',
};

export function OriginBadge({ kind }: { kind: OriginKind }) {
  return (
    <Badge variant="outline" className="text-xs font-normal">
      {LABEL[kind]}
    </Badge>
  );
}
